import { render, staticRenderFns } from "./TransitionBox.vue?vue&type=template&id=3114e2a0&scoped=true&"
import script from "./TransitionBox.vue?vue&type=script&lang=js&"
export * from "./TransitionBox.vue?vue&type=script&lang=js&"
import style0 from "./TransitionBox.vue?vue&type=style&index=0&id=3114e2a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3114e2a0",
  null
  
)

export default component.exports